// extracted by mini-css-extract-plugin
export default {"container":"EstimateTemplateMaterials_container__mfbEQ","item":"EstimateTemplateMaterials_item__vXHi6","closeField":"EstimateTemplateMaterials_closeField__eKDaB"};